<template>
    <div className=" w-[45%] py-[15px] mx-auto">
        <div class=" text-[20px] font-normal px-[25px] text-black text-center">
            Démissionner
        </div>
        <div class="text-black px-[25px] mt-4 text-[14px] font-extralight text-center">
            Les champs du formulaire suivis d'un <span class="text-[#f44545]">*</span> sont obligatoire. veuillez lire le formulaire
            avant soummition
        </div>
        <form @submit.prevent="addExit" class="px-[25px] text-black mt-4">
            <div class="w-full flex flex-col items-start pt-4 text-black">
                <label for="debut" class="font-light" >Date du départ<span class="text-[#f44545]">*</span></label>
                <input v-model="formdata.date" type="date" name="debut" class="h-[40px] w-full rounded-md border outline-none bg-[#f9fafb] p-3 focus:outline-none">
            </div>
            <div class="w-full flex flex-col items-start mt-2">
                <label for="detail" class="font-extralight">Motifs<span class="text-[#f44545]">*</span></label>
                <textarea v-model="formdata.motive" name="detail" id="" class="rounded-md bg-[#f9fafb] border p-5 h-[25vh] w-full"></textarea>
            </div>
            <div className="w-full mt-4 gap-x-3 flex items-center justify-end">
                <button type="submit" :disabled="asSend" class="w-full py-3 bg-[#5357ec] text-white rounded-md">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                    <span v-if="!asSend">Soumettre</span>
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import API from '@/service/API';
import toast from "../ui/toast";
import {
    Loader2
} from "lucide-vue-next";
export default {
    name: "ExitView",
    components:{Loader2},
    data(){
        return {
            asSend:false,
            formdata:{
                date: null,
                motive: null
            }
        }
    },
    methods:{
        addExit(){
            if(this.formdata.date.trim() === "" || this.formdata.motive.trim() === ""){
                toast.error("Erreur","Veuillez remplir tous les champs obligatoires",4000);
                return;
            }
            this.asSend = true;
            const data = {
                ...this.formdata,
                employee_id: localStorage.getItem("userId")
            }
            API.post("exits",data)
            .then((res)=>{
                if(res.data.status){
                    toast.success("Succès","Requête enregistré avec succès",4000);
                    this.formdata = {
                        date: null,
                        motive: null
                    }
                }
            })
            .catch(()=>{toast.error("Erreur","Erreur survenue sur le serveur",4000);})
            .finally(()=>{this.asSend = false;})
        }
    }
}
</script>